import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { usePrefs, useFlags, useRequestData } from 'wsm-common-data';
import clickpathGenerator from '../utils/clickpathGenerator';
import clickpathInjector from '../utils/clickpathInjector';
import { updateSession as trackingAttributesGenerator } from '../utils/trackingAttributesGenerator';
import trackingAttributesInjector from '../utils/trackingAttributesInjector';
import formTrackingAttributesInjector from '../utils/formTrackingAttributesInjector';
import setCookie from '../utils/setCookie';
import removeCookie from '../utils/removeCookie';
import { TrackedInfo } from '../global-constants';

// I think this is up here out of the widget component so it loads as fast as possible
// but I don't remember
if (typeof window !== 'undefined') {
	import('../utils/eventHandling/handleEvents.js').then((module) => {
		module.default(window);
	});
}

const trackedParamsAsCookies = [
	TrackedInfo.TCD_KEYWORD_ID,
	TrackedInfo.TCD_AD_ID,
	TrackedInfo.TCD_CAMPAIGN_ID,
	TrackedInfo.DDC_REF,
	TrackedInfo.GC_LID,
	TrackedInfo.T3_WEBSITE,
	TrackedInfo.ADP_FOUREYES
];

const Widget = () => {
	const { pii } = useSelector((state) => state);

	const { formChangeTypes, maxClickpathCount } = usePrefs();
	const { locale } = useRequestData();
	const flags = useFlags();
	const { 'enable-ws-tracking-attributes': enableTrackingAttributes } = flags;

	if (typeof window !== 'undefined') {
		window.DDC = window.DDC || {};
		window.DDC.WidgetData = window.DDC.WidgetData || {};
		window.DDC.WidgetData['ws-tracking'] =
			window.DDC.WidgetData['ws-tracking'] || {};
		window.DDC.WidgetData['ws-tracking'].formChangeTypes =
			formChangeTypes?.split(' ');
		window.DDC.WidgetData['ws-tracking'].confirmationData = {
			form: {
				fields: {
					...pii
				}
			}
		};
	}

	useEffect(() => {
		clickpathGenerator();
		clickpathInjector(parseInt(maxClickpathCount, 10));

		const urlParams = window.DDC.getUrlParams() || {};
		if (enableTrackingAttributes) {
			const { isDomainSSLEnabled, isSecureLoginEnabled } =
				window.DDC.siteSettings || {};
			trackingAttributesGenerator(urlParams);
			trackingAttributesInjector({ locale });
			formTrackingAttributesInjector({
				isDomainSSLEnabled,
				isSecureLoginEnabled
			});
		} else {
			const setCookies = trackedParamsAsCookies.some((trackedName) =>
				Object.keys(urlParams).includes(trackedName)
			);
			if (setCookies) {
				trackedParamsAsCookies.forEach((paramKey) => {
					const paramValue = urlParams[paramKey];
					if (paramValue) {
						setCookie(paramKey, paramValue, 30);
					} else {
						removeCookie(paramKey);
					}
				});
			}
		}
	});
	return <React.Fragment />;
};

export default Widget;
